import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./layout/Header";
import About from "./view/About";
import Contact from "./view/Contact";
import Home from "./view/Home";
import Fleet from "./view/Fleet";
import Safety from "./view/Safety";
import Ourservice from "./view/Ourservice";
import Footer from "./layout/Footer";
import FleetServices from "./view/FleetServices";
import ShuttleServices from "./view/ShuttleServices";
import AirportServices from "./view/AirportServices";

import 'aos/dist/aos.css';
import Retail from "./view/Retail";
import Corporate from "./view/Corporate";
import EmployeeTransportationServices from "./view/employeeTransportationServices";
// Check for token

class App extends Component {
  render() {
    return (
        
        <Router>
          <div>
            <Header />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/about-us" component={About} />
              <Route exact path="/contact-us" component={Contact} />
              <Route exact path="/our-services" component={Ourservice} />
              <Route exact path="/our-fleets" component={Fleet} />
              <Route exact path="/safety-standards" component={Safety} />
              <Route exact path="/fleet-service" component={FleetServices} />
              <Route exact path="/shuttle-services" component={ShuttleServices} />
              <Route exact path="/airport-services" component={AirportServices} />
              <Route exact path="/retail-services" component={Retail} />
              <Route exact path="/corporate-services" component={Corporate} />
              <Route exact path="/employee-transportation-services" component={EmployeeTransportationServices} />
            </Switch>
            <Footer />
          </div>
        </Router>
      
    );
  }
}

export default App;
